var cilDoor = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M400,464V64H112V464H16v32H496V464Zm-32,0H144V96H368Z' class='ci-primary'/><rect width='32' height='72' x='312' y='252' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilDoor };

